import React, { ReactNode } from 'react';
import { ParallaxBanner } from 'react-scroll-parallax';
import Reveal from './Reveal';

interface ParallaxSectionProps {
  backgroundImage: string;
  children: ReactNode;
  id?: string;
}

const ParallaxSection: React.FC<ParallaxSectionProps> = ({ 
  backgroundImage, 
  children, 
  id 
}) => {
  return (
    <div id={id} className="relative w-full py-8 md:py-12">
      <div className="max-w-screen-lg mx-auto px-4 relative z-10 mb-6">
        <Reveal>
          <div className="bg-white rounded-xl shadow-lg p-8">
            {children}
          </div>
        </Reveal>
      </div>

      <ParallaxBanner
        layers={[
          {
            image: backgroundImage,
            speed: -20,
            expanded: false,
          }
        ]}
        className="h-[30vh] md:h-[50vh]"
      />
    </div>
  );
};

export default ParallaxSection; 